module.exports = {"transport":"ws","websocket":"wss://d.dpays.io","uri":"https://api.dpays.io","url":"","dev_uri":"https://api.dpays.io","stage_uri":"https://api.dpays.io","address_prefix":"DWB","chain_id":"38f14b346eb697ba04ae0f5adcfaa0a437ed3711197704aa256a14cb9b4a8f26"}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 82
// module chunks = 0 1